import { render, staticRenderFns } from "./Tasto.vue?vue&type=template&id=1feae819&scoped=true&"
import script from "./Tasto.vue?vue&type=script&lang=js&"
export * from "./Tasto.vue?vue&type=script&lang=js&"
import style0 from "./Tasto.vue?vue&type=style&index=0&id=1feae819&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feae819",
  null
  
)

export default component.exports